const LABS_PREF = 'fslabs.labs'

const FLAGS_WITH_PREFS = {
  EXPOHALL: 'rootstech_expohall',
  PREVIEW: 'rootstech_preview',
  SITE_EXPERIENCE: 'rootstech_site_experience',
  CHAT_AUA_BUTTON: 'messaging_chat_aua_button',
  CHAT_ASKUSANYTHING: 'messaging_chat_askUsAnything',
  CHAT_HELPER: 'messaging_chat_helper',
}
const FLAGS_WITHOUT_PREFS = {
  BANNER_MAINTENANCE: 'rootstech_bannerMaintenance',
  CALL_FOR_PRESENTATIONS: 'rootstech_callForPresentations',
  CHAT: 'rootstech_chat',
  DASHBOARD: 'rootstech_dashboard',
  DAY_THEME: 'rootstech_day_theme',
  EMBEDDED_CHAT_FALLBACK: 'messaging_chat_show_embedded_fallback_for_all',
  EMBEDDED_CHAT: 'rootstech_embedded_chat',
  FORCE_LIVE: 'rootstech_force_live',
  HISTORY_DELETE: 'rootstech_history_delete',
  LATAM_EL_CAMINO: 'rootstech_latam_el_camino',
  LOG_GRAPHQL_DETAILS: 'rootstech_log_graphql_details',
  MARKETING: 'rootstech_marketing',
  NO_SESSION_COUNTDOWN: 'rootstech_no_session_countdown',
  PREVIEW_PATH_MAPPING: 'cpt_rootstech_preview_path_mapping',
  PERSIST_QUERIES: 'rootstech_persist_queries',
  QA_OPTIONS: 'rootstech_qa_options',
  QA_SCHEDULED_PLAYER: 'rootstech_qa_scheduled_player',
  RAR: 'rootstech_rar',
  SCHEDULE: 'rootstech_schedule',
  CALL_FOR_EXHIBITORS: 'cpt_rootstech_callForExhibitors',
  STORE: 'rootstech_store',
  VENDOR_CHAT: 'rootstech_vendor_chat',
  VOLUNTEER: 'rootstech_volunteer',
  EXTERNAL_NAVIGATION_OVERLAY: 'rootstech_external_nav_overlay',
  ONION_SKIN: 'rootstech_onion_skin',
  MERGED_IMAGE: 'cpt_zcms_merged_image',
  TOP_RATED_SESSIONS: 'cpt_rootstech_top_rated_sessions',
  TOP_WATCHED_SESSIONS: 'cpt_rootstech_top_watched_sessions',
  EARLY_BIRD_PRICING: 'cpt_rootstech_early_bird_pricing',
}

export const FLAGS = {
  ...FLAGS_WITH_PREFS,
  ...FLAGS_WITHOUT_PREFS,
}

export const flagsConfig = {
  flagsWithPrefs: [
    { flag: FLAGS.PREVIEW, pref: LABS_PREF },
    { flag: FLAGS.SITE_EXPERIENCE, pref: LABS_PREF },
    { flag: FLAGS.EXPOHALL, pref: LABS_PREF },
    { flag: FLAGS.CHAT_AUA_BUTTON, pref: LABS_PREF },
    { flag: FLAGS.CHAT_ASKUSANYTHING, pref: LABS_PREF },
    { flag: FLAGS.CHAT_HELPER, pref: LABS_PREF },
  ],
  flagsWithoutPrefs: Object.values(FLAGS_WITHOUT_PREFS),
}
